import { Competition, Elimination } from '@pool-league/shared-data-api';
import { CompetitionAttribute } from '@pool-league/frontend-web-ui-common';

export function getAttributes(
  competition?: Competition,
): CompetitionAttribute[] {
  if (!competition) {
    return [];
  }
  const attributes: CompetitionAttribute[] = [];

  if ('divisions' in competition) {
    attributes.push({
      label: 'Divisions',
      value: `${competition.divisions}`,
    });
  }

  if ('elimination' in competition) {
    attributes.push({
      label: 'Format',
      value:
        competition.elimination === Elimination.Double
          ? 'Double elimination'
          : 'Straight knockout',
    });
  }

  if ('entrants' in competition) {
    const entrantCount =
      typeof competition.entrants === 'number'
        ? competition.entrants
        : (competition.entrants as []).length;
    attributes.push({
      label: 'Entrants',
      value: `${entrantCount}`,
    });
  }

  return attributes;
}
